import { logger } from "@/utils/logger";
import { getMethodFrequencySlice, getMethodSeferlerSlice, dedupeFrequencyRowsByHour, } from "@/utils/optimizationData";
/** Vuex planStore.js createServices — frekans gridinden servis üretir */
function createServices(data, yon) {
    if (!data || data.length === 0) {
        logger.error(`${yon} için veri bulunamadı!`);
        return [];
    }
    return data
        .map((veri) => {
        const frekans = veri.frekans || 0;
        if (frekans <= 0) {
            logger.warn(`${yon} yönünde saat ${veri.saat} için frekans ${frekans}, servis oluşturulmayacak`);
            return [];
        }
        const interval = frekans > 0 ? 60 / frekans : 60;
        const servisler = [];
        logger.debug(`Saat ${veri.saat} için ${frekans} frekans, ${interval} dakika aralık oluşturuluyor`);
        for (let i = 0; i < frekans; i++) {
            const dakika = Math.floor(i * interval);
            const saat = veri.saat;
            const aracTipi = veri.arac_tipi || "SOLO";
            servisler.push({
                id: `${yon}_${saat}_${i}`,
                baslangic: `${String(saat).padStart(2, "0")}:${String(dakika).padStart(2, "0")}`,
                sure: 45,
                original_arac_tipi: aracTipi,
                arac_tipi: aracTipi,
                yon,
                _new: true,
            });
        }
        return servisler;
    })
        .flat();
}
function splitBackendSeferler(seferler, defaultAracTipi = "SOLO") {
    const gidis = [];
    const donus = [];
    seferler.forEach((s, idx) => {
        const yon = s.yon === "donus" ? "donus" : "gidis";
        const aracTipi = s.arac_tipi || defaultAracTipi;
        const servis = {
            id: s.id || `${yon}_${s.baslangic}_${idx}`,
            baslangic: s.baslangic,
            bitis: s.bitis || null,
            sure: s.sure,
            yon,
            original_arac_tipi: aracTipi,
            arac_tipi: aracTipi,
            arac_id: s.arac_id,
            _fromBackend: true,
            ...(s._synced
                ? { _synced: true, _syncMeta: s._syncMeta || null }
                : {}),
        };
        if (yon === "gidis")
            gidis.push(servis);
        else
            donus.push(servis);
    });
    return { gidis, donus };
}
/** Vuex planStore.js createMethodPlan — micro-5-4 generateAllBasePlans için */
export function createMethodPlan(optimizationData, methodKey, analysisData = null) {
    const opt = optimizationData || {};
    const anal = analysisData || {};
    if (!opt.gidis && !opt.donus && !anal.gidis) {
        logger.error("Geçersiz optimizasyon verisi (gidis/donus yok)");
        return { gidis: [], donus: [] };
    }
    const backendSeferler = getMethodSeferlerSlice(opt, anal, methodKey);
    if (backendSeferler.length > 0) {
        return splitBackendSeferler(backendSeferler);
    }
    const gidisFreq = dedupeFrequencyRowsByHour(getMethodFrequencySlice(opt, anal, "gidis", methodKey));
    const donusFreq = dedupeFrequencyRowsByHour(getMethodFrequencySlice(opt, anal, "donus", methodKey));
    if (gidisFreq.length > 0 || donusFreq.length > 0) {
        logger.warn(`[${methodKey}] Backend seferler yok; frekans gridinden geçici servis planı üretiliyor.`);
        return {
            gidis: createServices(gidisFreq, "gidis"),
            donus: createServices(donusFreq, "donus"),
        };
    }
    logger.error(`[${methodKey}] Servis planı oluşturulamadı (seferler ve frekans verisi yok).`);
    return { gidis: [], donus: [] };
}
/** Vuex planStore.js syncServiceBitis — servis bitiş saatini süreden hesaplar */
export function syncServiceBitis(service) {
    if (!service?.baslangic || service.sure == null || service.sure === "") {
        return service;
    }
    const sure = Number(service.sure);
    if (!Number.isFinite(sure) || sure <= 0)
        return service;
    const [h, m] = service.baslangic.split(":").map(Number);
    let total = h * 60 + m + sure;
    total = ((total % (24 * 60)) + 24 * 60) % (24 * 60);
    return {
        ...service,
        bitis: `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`,
    };
}
